module.exports = __webpack_public_path__ + "img/last-month-earn.1e565a04.svg";